import React from 'react';
import PromotionalLinkCopy from './components/ModalPromotionalLinkEducation/PromotionalLinkCopy';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { useTranslation } from 'react-i18next';

export default function RequirementPromotionalText() {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const utmLink = detailData?.order?.utmLink;
  return (
    <div className="w-full">
      <span className="text-text-color-primary text-sm font-bold font-['Inter'] leading-snug">
        {!!utmLink
          ? t(
              'config.requirementPromotionalText.use_promotional_link_with_colon',
              {
                defaultValue: 'Use the promotional link: '
              }
            )
          : detailData?.campaign?.landingpageurlMode === 'manual'
            ? t(
                'config.requirementPromotionalText.use_promotional_link_provided_by_brand',
                {
                  defaultValue: 'Use the promotional link provided by brand '
                }
              )
            : t(
                'config.requirementPromotionalText.use_promotional_link_provided',
                {
                  defaultValue:
                    'Use the promotional link provided by AhaCreator '
                }
              )}
      </span>
      {!!utmLink && <PromotionalLinkCopy utmLink={utmLink} />}
      <span className="text-text-color-primary text-sm font-normal font-['Inter'] leading-snug">
        {t('config.requirementPromotionalText.not_official_link', {
          defaultValue: ', not the official website link or a redirected link.'
        })}
      </span>
    </div>
  );
}
